import React from "react";
import Card from "./Card";
import logo from "../assets/logoBlack.png";
import whiteSofa from "../assets/whiteSofa.png";
import liftingSofa from "../assets/liftingSofa.png";
import storage from "../assets/storage.png";
import truck from "../assets/truck.png";


function CardList() {
  const cards = [
    {
      image: liftingSofa,
      title: "Domestic Moving",
      description:
        "Relocating Brothers Packers Movers from one place to another is not so easy. It requires time, effort, and of course the risk of security. Shifting your house from one city to another becomes so quick and convenient.",
    },
    {
      image: storage,
      title: "Local Shifting",
      description:
        "The safe and proper packaging of goods is of paramount importance to us. We, Brothers Packers Movers Mover, details while packaging processes and to Brothers Packers Movers goods moving services. ",
    },
    {
      image: truck,
      title: "Car Transport",
      description:
        "As the name indicates we focus on providing an excellent shift encounter for companies. We are dedicated to understanding our customer’s company and shift objectives before developing a shift package that features these needs together with best shift methods. ",
    },
    {
      image: storage,
      title: "Warehouse",
      description:
        "Our dedicated or shared warehousing services included bonded warehousing, through which packers and movers in chennai service provider stores dutiable goods and manages all the necessary customers regulations on the behalf of clients during the period of storage. ",
    },
    {
      image: whiteSofa,
      title: "Assembly of furniture",
      description:
        "Hifting of a S V Packers Movers or office is a very lengthy and hectic process and it takes lots of effort and time to perfectly move from one place to another place. We are always ready to help you in this boring and hectic process and look out of all your requirements.",
    },
    {
      image: truck,
      title: "Bike Transport",
      description:
        "You are all set to move to a new city and you have a lot on your plate. You are anticipating a fresh start. But there are some other things which you must take Bike of first – like Bike transportation services in Chennai .",
    },
  ];

  return (
    <div className="bg-slate-800">
      <section className="max-w-7xl mx-auto bg-slate-800 p-5 xl:p-0">
        <br />
        <br />
        <h2 className="text-4xl font-semibold mb-12 text-white">
          Brothers moving <br />{" "}
          <span className="text-green-600">solutions</span>
        </h2>
        <div className="justify-center flex flex-wrap xl:justify-between lg:justify-between md:justify-between align-middle">
          {cards.map((i) => (
            <Card image={i.image} title={i.title} description={i.description} />
          ))}
        </div>
      </section>
    </div>
  );
}

export default CardList;
